import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { getGameImages } from '../../../core/helpers/getGameImages';
import IconBackGround from '../../common/iconBackGround';
import { isMobile } from '../../../core/helpers/isMobile';

const QuickBetsPagination = observer(({ x, y, quickBetsPaginationElementMargin }) => {
  const { quickBetsPaginationList, selectedQuickBetPage, setSelectedQuickBetPage } =
    bettingPartStore;
  const {
    paginationIconBgDefault,
    paginationIconBgPressed,
    paginationIconBgHovered,
    paginationIconBgSelected,
  } = useMemo(() => {
    return getGameImages();
  }, []);

  const additionalBackGroundImages = useMemo(() => {
    return {
      iconBgDefault: paginationIconBgDefault,
      iconBgDisabled: paginationIconBgDefault,
      iconBgHovered: paginationIconBgHovered,
      iconBgPressed: paginationIconBgPressed,
      iconBgSelected: paginationIconBgSelected,
    };
  }, [
    paginationIconBgDefault,
    paginationIconBgPressed,
    paginationIconBgSelected,
    paginationIconBgHovered,
  ]);

  const handleChangePagination = useCallback(
    (value) => {
      setSelectedQuickBetPage(value);
    },
    [setSelectedQuickBetPage]
  );

  const handlePointerUp = useCallback(
    (e, value) => {
      handleChangePagination(value);
    },
    [handleChangePagination]
  );

  return (
    <Container
      x={
        x -
        (quickBetsPaginationList.length * quickBetsPaginationElementMargin) / 2 +
        quickBetsPaginationElementMargin / 2
      }
      y={y}
    >
      {quickBetsPaginationList.map((el, index) => {
        return (
          <IconBackGround
            key={el}
            x={index * quickBetsPaginationElementMargin}
            additionalBackGroundImages={additionalBackGroundImages}
            handleSelect={(e) => handlePointerUp(e, el)}
            isSelect={+el === +selectedQuickBetPage}
            scale={isMobile() ? 0.78 : 0.51}
          >
            <Text text={`${el}`} style={{ _fill: '#FFFFFF' }} anchor={0.5} resolution={2} />
          </IconBackGround>
        );
      })}
    </Container>
  );
});
export default QuickBetsPagination;
